import React from 'react';
import { motion } from 'framer-motion';
import Marquee from '../Marquee';
import { ArrowUpRight } from 'lucide-react';
import { BG_GLOW } from '../../mock';

export default function BookACall() {
  return (
    <section id="book" className="relative bg-[var(--bg)] pt-20 md:pt-28 pb-20 md:pb-28 overflow-hidden">
      <Marquee items={['PRONTO PARA ME CONTRATAR?', 'PRONTO PARA ME CONTRATAR?', 'PRONTO PARA ME CONTRATAR?', 'PRONTO PARA ME CONTRATAR?']} speed={8} className="border-y border-[var(--border)]" />


      <div className="relative max-w-6xl mx-auto px-6 md:px-10 mt-20 md:mt-28 text-center">
        <div
          className="absolute -inset-10 md:-inset-20 -z-0 opacity-40 pointer-events-none scale-150 optimized-glow"
          style={{
            '--glow-image': `url(${BG_GLOW})`,
            filter: 'blur(80px) saturate(150%)',
            maskImage: 'radial-gradient(circle at center, black 30%, transparent 70%)',
            WebkitMaskImage: 'radial-gradient(circle at center, black 30%, transparent 70%)',
          }}
        />

        <motion.h2
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9 }}
          className="relative z-10 font-display text-4xl md:text-6xl lg:text-7xl uppercase tracking-tight leading-[1.05]"
        >
          PRONTO PARA ME CONTRATAR?
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.15 }}
          className="relative z-10 mt-6 max-w-xl mx-auto text-sm md:text-base text-white/70 leading-relaxed"
        >
          Vamos conversar sobre como podemos dar vida às suas ideias. Entre em contato comigo e vamos juntos definir os próximos passos.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="relative z-10 mt-10"
        >
          <a
            href="https://api.whatsapp.com/send?1=pt_BR&phone=5535984641337"
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex items-center gap-3 px-8 py-4 rounded-full bg-gradient-to-r from-[var(--accent)] to-[var(--accent-secondary)] text-black font-semibold tracking-[0.2em] text-sm hover:shadow-[0_10px_50px_rgba(255,90,31,0.5)] transition-shadow"
          >
            QUERO CONVERSAR!

            <ArrowUpRight size={18} strokeWidth={2.5} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
          </a>
        </motion.div>
      </div>
    </section>
  );
}
